var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessType({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2943_6178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9871 0.765625L0 9.73707L4.34977 24.2341H19.6244L24 9.73707L11.9871 0.765625ZM16.8953 11.1225L12.9277 6.24383V3.80975L20.9199 9.7784L16.8953 11.1225ZM11.9883 13.7504L11.9888 13.749H11.9903L11.9908 13.7504L11.9895 13.7514L11.9883 13.7504ZM11.0515 12.4468L8.98369 11.7547L11.0515 9.21258V12.4468ZM10.4787 14.2336L9.46212 15.6327L8.82796 13.6811L10.4787 14.2336ZM11.9896 15.3461L13.8875 17.9583L10.7057 17.1132L11.9896 15.3461ZM13.501 14.2343L15.5894 13.5367L15.408 16.8591L13.501 14.2343ZM12.9277 12.4477V9.21751L14.9935 11.7577L12.9277 12.4477ZM11.0515 6.23933L7.08273 11.1185L3.07696 9.77774L11.0515 3.80938V6.23933ZM6.61448 12.9402L8.09906 17.5089L5.40386 21.2186L2.50749 11.5656L6.61448 12.9402ZM9.52342 18.7405L15.6351 20.3637L17.084 22.3579H6.8952L9.52342 18.7405ZM17.1557 19.2645L17.5034 12.8975L21.488 11.5667L18.575 21.218L17.1557 19.2645Z",
    fill: "#4D2481"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2943_6178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessType);
export default __webpack_public_path__ + "static/media/business-type.15cd1338962456e1208b16eae99c4554.svg";
export { ForwardRef as ReactComponent };